export default __webpack_public_path__ + "static/data-acquisition-v2-c30f32b456bea6ae56f5797e044a9dba.svg";